import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { EmptyState } from '../components/ui/Card';
import { t } from '../i18n';

export function NotFound() {
  return (
    <EmptyState title={t('Stránka sa nenašla')}>
      <p className="mb-4">{t('Požadovaná stránka neexistuje.')}</p>
      <Link to="/">
        <Button variant="outline">{t('Späť na prehľad')}</Button>
      </Link>
    </EmptyState>
  );
}
